var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconRecoverSuccess = function SvgIconRecoverSuccess(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 32C62 15.4585 48.5415 2 32 2C15.4585 2 2 15.4585 2 32C2 48.5415 15.4585 62 32 62C48.5415 62 62 48.5415 62 32ZM4.7468 32C4.7468 17.7986 17.7986 4.7468 32 4.7468C46.2014 4.7468 59.2532 17.7986 59.2532 32C59.2532 46.2014 46.2014 59.2532 32 59.2532C17.7986 59.2532 4.7468 46.2014 4.7468 32Z",
    fill: "#007FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3612 24.8889C35.454 29.0648 32.5296 32.5108 28.8006 36.5415L24.5569 32.718C24.2369 32.428 23.7959 32.3427 23.4008 32.4943C23.0056 32.6458 22.7166 33.0112 22.6431 33.4521C22.5696 33.893 22.7228 34.3422 23.0448 34.6297L28.1177 39.2075C28.5846 39.6257 29.2742 39.5917 29.703 39.1295C33.8896 34.6551 36.8814 31.0675 41.0196 26.6446C41.3828 26.2687 41.4783 25.6864 41.2564 25.2012C41.0345 24.7161 40.5454 24.438 40.0441 24.5118C39.7831 24.5519 39.5425 24.6848 39.3612 24.8889Z",
    fill: "#007FFF"
  })));
};
export default SvgIconRecoverSuccess;